module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_ynx-85446ae170a8a75594129d70a9acc6a1.png";